let TireDetailPanel = {
    quantity: null,
    singleTirePrice: null,
    discountRuleId: null,
    discountDesc: null,
    promoDiscount: null,
    dollarAmount: null,
    percentAmount: null,
    minAmount: null,
    feeTotal: 0,
    fees: [],

    init: function () {
        //hookup tooltips
        jQuery('.tooltip-hover').tooltip({
            trigger: 'hover focus',
            container: 'body',
            html: true
        });

        jQuery('.tire-detail-back-to-search-mobile, .tire-detail-back-to-search').on("click", function () {
            if (window.history.length > 1) {
                window.history.back();
            } else if (localStorage.getItem('searchID')) {
                let search = localStorage.getItem('searchID');
                window.location = `/tire-search?${search}`;
            }
        });

        //hookup events 
        TireDetailPanel.makeApptBtnEvent();
        TireDetailPanel.groupAddOnsEvent();

        //store unchanging values for use later
        TireDetailPanel.singleTirePrice = jQuery('#single-tire-price').text();

        let tireDiscountEle = jQuery('.tire-discount-value').first();
        TireDetailPanel.discountRuleId = tireDiscountEle.data('discountRuleId');
        TireDetailPanel.discountDesc = tireDiscountEle.data('discountDesc');
        TireDetailPanel.dollarAmount = tireDiscountEle.data('dollarAmount');
        TireDetailPanel.percentAmount = tireDiscountEle.data('percentAmount');
        TireDetailPanel.minAmount = tireDiscountEle.data('minAmount');

        //quantity select change event
        jQuery('#tire-qty-select').on('change', function () {
            //new subtotal = selected quantity * price of a single tire
            TireDetailPanel.quantity = parseInt(jQuery(this).val());

            //update tire promo (if exists)
            if (TireDetailPanel.discountRuleId) {
                TireDetailPanel.promoDiscount = Util.getPromoDiscount(
                    TireDetailPanel.discountRuleId,
                    TireDetailPanel.quantity,
                    TireDetailPanel.singleTirePrice,
                    TireDetailPanel.percentAmount,
                    TireDetailPanel.dollarAmount,
                    TireDetailPanel.minAmount
                );

                //update and show the discount wrapper as needed
                if (TireDetailPanel.promoDiscount) {
                    jQuery('.tire-discount-value').text(TireDetailPanel.promoDiscount);
                    jQuery('#tire-discount-wrapper').show();
                } else {
                    jQuery('#tire-discount-wrapper').hide();
                    TireDetailPanel.promoDiscount = 0;
                }
            }

            TireDetailPanel.calculateTotals();
        });

        jQuery('.tire-add-on input').on('change', function () {
            TireDetailPanel.calculateTotals();
        });

        //position for mobile on load
        TireDetailPanel.repositionForMobile();

        //event handler for window resize
        jQuery(window).resize(function () {
            TireDetailPanel.repositionForMobile();
        });

        //email quote form submit handler
        jQuery('#tire-email-quote-form').submit(function (e) {
            e.preventDefault();

            //grab the input values from the email tire quote form
            let values = {};
            jQuery('#tire-email-quote-form input').each(function () {
                values[this.name] = jQuery(this).val(); //store the input value
                jQuery(this).val(""); //and then empty it out
            });

            TireDetailPanel.saveQuote(values);
            TireDetailPanel.emailQuote(values);

            jQuery('#tire-email-quote-form').hide('fast');
            jQuery('#email-confirmation-msg').show('slow');

            return false;
        });

        //reset the form once it is closed
        jQuery('#tire-email-quote-modal').on('hidden.bs.modal', function () {
            jQuery('#email-confirmation-msg').hide();
            jQuery('#tire-email-quote-form').show();
        });

        //populate the TireDetailPanel variables, to make sure the email quote has the info it needs
        jQuery('#tire-qty-select').trigger('change');
    },
    repositionForMobile: function () {
        //get viewport of window
        var viewPort = parseInt(jQuery(window).innerWidth());

        //logic for moving tire image/thumbnails
        if (viewPort < Util.getBreakpoint('xl')) {
            //move detail image wrapper for mobile
            TireDetailPanel.moveElement('#tire-detail-image-wrapper', '#tire-detail-review-wrapper');
        } else if (viewPort >= Util.getBreakpoint('xl')) {
            //move detail image wrapper for desktop
            TireDetailPanel.moveElement('#tire-detail-image-wrapper', '#tire-info-wrapper');
        }

        //logic for moving quote section
        if (viewPort < Util.getBreakpoint('lg')) {
            //move detail quote for mobile
            TireDetailPanel.moveElement('#tire-detail-quote-wrapper', '#tire-detail-info');
        } else if (viewPort >= Util.getBreakpoint('lg')) {
            //move detail quote for desktop
            TireDetailPanel.moveElement('#tire-detail-quote-wrapper', '#tire-detail-info-wrapper');
        }
    },
    moveElement: function (elementToMove, elementToAppendAfter) {
        var destination = jQuery(elementToAppendAfter);
        var toMove = jQuery(elementToMove);
        jQuery(toMove).insertAfter(destination);
    },
    calculateTotals: function () {
        let newSubtotal = TireDetailPanel.quantity * TireDetailPanel.singleTirePrice;

        //format function from https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-dollars-currency-string-in-javascript 
        jQuery('#tire-subtotal').text(newSubtotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));

        //total all selected add-ons
        TireDetailPanel.feeTotal = 0;
        TireDetailPanel.fees = [];

        jQuery('.tire-add-on input:checked').each(function () {
            let multiplier = jQuery(this).data('perTire') === 1 ? TireDetailPanel.quantity : 1; //account for per tire pricing
            TireDetailPanel.feeTotal += multiplier * jQuery(this).data('addOnPrice');

            let children = [];
            jQuery('li[data-parent-id="' + jQuery(this).data('addOnId') + '"]').each(function () {
                children.push(jQuery(this).text());
            })

            TireDetailPanel.fees.push({
                "perTire": jQuery(this).data('perTire'),
                "fee": jQuery(this).data('addOnPrice'),
                "name": jQuery('label[for=' + jQuery(this).prop('id') + ']').text().trim(),
                "children": children
            });
        });

        //update displayed total
        if (TireDetailPanel.discountRuleId === 23) {
            TireDetailPanel.promoDiscount = TireDetailPanel.promoDiscount * 3;
        }
        let newTotal = newSubtotal + TireDetailPanel.feeTotal - TireDetailPanel.promoDiscount;
        jQuery('#total-price').text(newTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
    },
    saveQuote: function (values) {
        let vehicleInfo = JSON.parse(Util.getCookie('vehicle_info') || "{}");
        let storeId = parseInt(Util.getCookie('store_location') || 0);
        let sku = jQuery('.spec-name:contains("item number")').next('.spec-value').text();
        let size = jQuery('.spec-name:contains("size")').next('.spec-value').text();
        let [image] = jQuery('#tire-detail-image-full img').attr('src').split('/').reverse();
        let [sectionWidth, ...tireSize] = size.split('/');
        let [aspectRatio, rimSize] = tireSize.toString().split('R');

        let tireSummary = {
            makeModel: jQuery('#tire-detail-make-logo').attr("alt").trim() + ' - ' + jQuery('#tire-detail-model').text().trim(),
            size: size,
            sku: sku,
            type: jQuery('#tire-detail-type').text().trim(),
            image: image,
            qty: TireDetailPanel.quantity,
            tireOnlyPrice: jQuery('#single-tire-price').text(),
            subtotal: jQuery('#tire-subtotal').text(),
            total: jQuery('#total-price').text(),
            tireRebate: jQuery('.tire-discount-value').text().trim(),
            fees: TireDetailPanel.fees,
            tireRebateDescription: jQuery('.tire-discount-type').text(),
        }

        let dataObj = {
            "FirstName": values.firstName,
            "LastName": values.lastName,
            "Email": values.email,
            "StoreId": storeId,
            "OptInPromotion": "true",
            "VehicleMake": vehicleInfo['ts-make'],
            "VehicleModel": vehicleInfo['ts-model'],
            "VehicleYear": parseInt(vehicleInfo['ts-year']),
            "VehicleOptions": vehicleInfo['ts-option'],
            "Tires": JSON.stringify(tireSummary),
            "Tire1SectionWidth": parseInt(sectionWidth),
            "Tire1AspectRatio": parseInt(aspectRatio),
            "Tire1RimSize": parseInt(rimSize),
            "Tire1SkuNumber": sku,
            "Tire2SectionWidth": 0,
            "Tire2AspectRatio": 0,
            "Tire2RimSize": 0,
            "Tire2SkuNumber": ""
        }

        // Remove data fields that are null or empty
        jQuery.each(dataObj, function (key, val) {
            if (val === null || val === '' || val === 0) {
                delete dataObj[key];
            }
        });

        // Post request
        jQuery.ajax({
            url: Util.lambdaHost + 'quote/create',
            beforeSend: function (request) {
                request.setRequestHeader('x-api-key', Util.lambdaApiKey);
            },
            dataType: 'json',
            type: "POST",
            data: JSON.stringify(dataObj),
            contentType: "application/json;charset=utf-8",
            success: function (response) {
                console.log(response)
            },
            error: function (response) {
                console.log(response);
            }
        });
    },
    emailQuote: function (values) {
        let tireInfo = {
            "quantity": TireDetailPanel.quantity,
            "sku": jQuery('.spec-name:contains("item number")').next('.spec-value').text(),
            "size": jQuery('.spec-name:contains("size")').next('.spec-value').text(),
            "make": jQuery('#tire-detail-make').text(),
            "model": jQuery('#tire-detail-model').text(),
            "perTire": TireDetailPanel.singleTirePrice,
            "subtotal": jQuery('#tire-subtotal').text(),
            "total": jQuery('#total-price').text(),
            "fees": TireDetailPanel.fees,
            "feeTotal": TireDetailPanel.feeTotal,
            "discountRuleId": TireDetailPanel.discountRuleId,
            "discountDesc": TireDetailPanel.discountDesc,
            "promoDiscount": TireDetailPanel.promoDiscount
        };

        jQuery.ajax({
            url: window.location.origin + '/wp-json/monro/v1/email/tire-quote',
            type: 'POST',
            data: {
                to: [values.email],
                subject: '{{brandName}} - Price Quote',
                template: 'tire-quote',
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                tireInfo: JSON.stringify(tireInfo)
            },
            success: function (response) {
                console.log(response);
            },
            error: function (response) {
                console.log(response);
            }
        });
    },
    makeApptBtnEvent: function () {
        jQuery('#tire-detail-make-appt').on('click', function () {
            let sku = jQuery('.spec-name:contains("item number")').next('.spec-value').text();
            let couponId = jQuery('.tire-discount-value').first().data('discountCouponId');
            let addOns = [];

            jQuery('.tire-add-on input:checked').each(function () {
                addOns.push(jQuery(this).data('addOnId'));
            });

            //store the tire selected, quantity, and promo if
            Util.setCookie('apptTireSku', sku);
            Util.setCookie('apptTireQty', TireDetailPanel.quantity);
            Util.setCookie('apptTirePromo', couponId);
            Util.setCookie('apptAddOns', JSON.stringify(addOns));

            //redirect to the appointment pages
            window.location = '/appointment/services-info';
        });
    },
    groupAddOnsEvent: function () {
        jQuery('.tire-add-on input').on('change', function () {
            let addOnId = jQuery(this).data('addOnId');
            let groupId = jQuery(this).data('groupId');

            //account for addons that don't have a group
            if (!groupId) {
                return;
            }

            let groupMembers = jQuery('input[data-group-id="' + groupId + '"]').toArray();

            //toggle the checked state of the first group member found that is not the source of the event
            groupMembers.forEach((member) => {
                let checkbox = jQuery(member);
                if (checkbox.data('add-on-id') !== addOnId) {
                    checkbox.prop('checked', !checkbox.prop('checked'));
                }
                return;
            });
        });
    }
};